var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBullito(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 157.31 166.88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{stroke:#36a9e1;stroke-linecap:round;stroke-linejoin:round;stroke-width:3px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_5",
    "data-name": "Capa 5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M184.53,209.22a1.9,1.9,0,0,1-1.51,2.62,1.87,1.87,0,0,1-1.41-.38c-5-3.9-38.92-30.58-42.46-45.44h0a10.32,10.32,0,0,1-.29-2.39,9.93,9.93,0,0,1,.44-2.37v0c4.41-14.62,39.82-39.24,45.08-42.84a1.86,1.86,0,0,1,1.43-.29,1.89,1.89,0,0,1,1.35,2.7c-3.66,7.47-16.08,31.67-28.5,43.4C170.36,176.65,181.31,201.55,184.53,209.22Z",
    transform: "translate(-121.34 -116.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M139.14,166a6.74,6.74,0,0,1-.29-2.39A10.32,10.32,0,0,0,139.14,166Z",
    transform: "translate(-121.34 -116.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M264.34,167.34a10.12,10.12,0,0,1-.44,2.37h0c-4.42,14.62-39.82,39.25-45.08,42.85a2,2,0,0,1-1.43.29,1.9,1.9,0,0,1-1.35-2.71c3.66-7.46,16.07-31.67,28.49-43.4-11.7-12.45-22.66-37.34-25.87-45a1.9,1.9,0,0,1,2.92-2.23c5,3.9,38.92,30.58,42.46,45.43v0A10.22,10.22,0,0,1,264.34,167.34Z",
    transform: "translate(-121.34 -116.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M264.34,167.34a6.57,6.57,0,0,1-.44,2.37A10.12,10.12,0,0,0,264.34,167.34Z",
    transform: "translate(-121.34 -116.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M212.58,281.91l-28.85-.86c-44.21-1.31-73.52-47-55.48-87.41,10-22.46,19.17-5,31.26-22,18.74-26.37,29.27.87,41.86,1.24s24.73-26.19,41.87,1.25c11.06,17.71,21.22.82,29.9,23.83C288.75,239.32,256.79,283.22,212.58,281.91Z",
    transform: "translate(-121.34 -116.56)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 55.57,
    cy: 64.36,
    r: 11.14
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M184.56,189A11.14,11.14,0,0,1,171,190.34a30.61,30.61,0,0,1,13-18.07,10.45,10.45,0,0,1,1.09,1A11.14,11.14,0,0,1,184.56,189Z",
    transform: "translate(-121.34 -116.56)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 103.97,
    cy: 65.8,
    r: 11.14
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M230.69,192.11a11.14,11.14,0,0,1-13-17.86,12.87,12.87,0,0,1,1.15-.95A30.61,30.61,0,0,1,230.69,192.11Z",
    transform: "translate(-121.34 -116.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M226,205.13c-.41,13.75-12,16.48-26.1,16.06s-25.51-3.83-25.1-17.58,12.29-27.75,26.43-27.33S226.45,191.39,226,205.13Z",
    transform: "translate(-121.34 -116.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M193.05,186.39c2.07,2.19,13.76,2.42,15.84.47",
    transform: "translate(-121.34 -116.56)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBullito);
export default __webpack_public_path__ + "static/media/bullito.372850fa3676d174fb00098b82e3efb2.svg";
export { ForwardRef as ReactComponent };